//const slide = document.querySelector('.n2-ss-slide.n2-ow.n2-ss-slide-active');
document.addEventListener('DOMContentLoaded', () => {
    // Le DOM est chargé, vous pouvez maintenant sélectionner votre diapositive et lancer l'animation
    const slides = document.querySelectorAll('.carousel .carousel-item img');
    let delay = 4000; // Délai en millisecondes entre chaque animation
    // ... votre code pour lancer l'animation
    if (slides.length > 0) {
        //alert('Image de background chargée | premiere fonction  sur img');
        //alert((slides.length).toString());
        console.log(`${slides.length} image(s) trouvée(s).`);
        //slide.classList.add('zoom-in');
        slides.forEach((slide, index) => {
            setTimeout(() => {
                slide.classList.remove('zoom-in');
                slide.classList.add('zoom-in');
            }, index * delay);
        });
    }else{
        //alert('Pas d\'image bg sur ce slide | premiere fonction');
        console.warn('Pas d\'image bg sur ce slide | premiere fonction');
    }
});


// Supposons que la bibliothèque de slider déclenche un événement "slideChanged"
/*document.addEventListener('DOMContentLoaded', () => {
    const slides = document.querySelectorAll('.n2-ss-slide-background-image img');
    const slider = document.querySelector('.n2-ss-slide-background'); // Sélectionnez votre élément slider

    slider.addEventListener('slideChanged', () => {
        // Supprimer la classe d'animation de toutes les images
        slides.forEach(slide => {
            slide.classList.remove('zoom-in');
        });

        // Trouver la slide active et lui appliquer l'animation
        const activeSlide = document.querySelector('.n2-ss-slide-background-image img');
        activeSlide.classList.add('zoom-in');
    });
});*/